export const REGISTRATION_ACTIONS = {
  started: 'registration:started',
  emailVerified: 'registration:email_verified',
  consentAccepted: 'registration:consent_accepted',
  profileSubmitted: 'registration:profile_submitted',
  enrolledWithEnrolmentCode: 'registration:enrolled_with_enrolment_code',
  enrolledWithTrustBasedEligibility: 'registration:enrolled_with_trust_based_eligibility',
  unchallengedEnrolmentSucceeded: 'registration:unchallenged_enrolment_succeeded',
  unchallengedEnrolmentFailed: 'registration:unchallenged_enrolment_failed',
  challengedEnrolmentSucceeded: 'registration:challenged_enrolment_succeeded',
  challengedEnrolmentFailed: 'registration:challenged_enrolment_failed',
  mfaEnabled: 'registration:mfa_enabled',
} as const
